import { apiClient } from "../config";

async function archiveCommunity(id: any, status: any) {
  const url = `/admin/communities/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveCommunity;
